export default __webpack_public_path__ + "static/media/home-menu.09c5006b.png";